/**
 * Copia un testo negli appunti. Restituisce `false` se il browser non lo permette (contesto non
 * sicuro, permesso negato): chi chiama mostra allora un messaggio.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  const clipboard = typeof navigator === 'undefined' ? undefined : navigator.clipboard;
  if (!clipboard?.writeText) {
    return false;
  }
  try {
    await clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
